import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { StateType } from '../../../state/reducers';

export type filterActionTypes =
  | 'all_filters'
  | 'date'
  | 'jurisdiction'
  | 'domain'
  | 'sort'
  | 'editor'
  | 'others'
  | 'content_type';

export function reportFilterToggle(
  searchType: StateType['queryParams']['type'],
  type: filterActionTypes,
  checked: boolean,
) {
  if (checked) {
    doctrineAnalytics('Search FilterOpened', { searchType, type });
  } else {
    doctrineAnalytics('Search FilterClosed', { searchType, type });
  }
}
